
import BaseInput from "@/components/base/BaseInput.vue";
import { maska } from "maska";
import { computed, defineComponent } from "vue";

export default defineComponent({
	directives: { maska },
	inheritAttrs: false,
	props: {
		name: String,
		modelValue: {
			type: String,
			required: true,
		},
		label: String,
		hasError: Boolean,
		errors: Array,
		disabled: Boolean,
		valid: Boolean,
		hasCalendarPopup: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		BaseInput,
	},
	setup(props, { emit }) {
		const inputValue = computed({
			get(): string {
				return props.modelValue;
			},
			set(value: string) {
				if (value.length === 10 || value.length === 0) {
					emit("update:modelValue", value);
				}
			},
		});

		return { inputValue };
	},
});
